// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Estimate_estimate__6NItI {
  width: 660px;
  margin: 0 20px;
}

.Estimate_product__JgcDq {
  border: 1px solid #d8d8ff;
  background-color: #FFFFFF;
  padding: 20px;
  border-radius: 12px;
  color: #00007a;
  margin-top: 28px;
}
.Estimate_product__JgcDq h2 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
}
.Estimate_product__JgcDq h3 {
  font-size: 16px;
  font-weight: 400;
  width: calc(100% - 25px);
  margin: 10px 0 5px 5px;
}
.Estimate_product__JgcDq svg {
  width: 20px;
  height: auto;
  vertical-align: middle;
}
.Estimate_product__JgcDq ul {
  border-top: 1px solid #d8d8ff;
  margin-top: 20px;
  margin-bottom: 0;
  padding-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.Estimate_product__JgcDq ul li {
  width: calc(50% - 8px);
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.Estimate_title__Zv8Gm {
  margin-bottom: 5px !important;
}

.Estimate_link__x50Jl a {
  color: #0000c9 !important;
  text-decoration: underline;
}

.Estimate_price__xjXW7 {
  display: block;
  font-size: 20px;
  font-weight: 500;
  margin-top: 15px;
  margin-bottom: 10px;
}

.Estimate_message__TWdH1 {
  width: 348px;
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #d8d8ff;
  padding: 12px;
  border-radius: 12px;
  font-weight: 300;
  font-size: 14px;
  color: #00007a;
  margin: 0 20px 16px 20px;
  float: right;
}
.Estimate_message__TWdH1 path {
  fill: #4343ff;
}

.Estimate_clear__7zrRE {
  clear: both;
  float: right;
}

.Estimate_basket__L8u2X {
  width: 348px;
  border: 1px solid #d8d8ff;
  background-color: #FFFFFF;
  padding: 20px;
  border-radius: 12px;
  color: #00007a;
  float: right;
  margin: 0 20px;
}
.Estimate_basket__L8u2X h2 {
  font-size: 20px;
  font-weight: 500;
}
.Estimate_basket__L8u2X .Estimate_quantity__4FbNK {
  display: none;
}
.Estimate_basket__L8u2X .Estimate_toggle__tc5K2 {
  width: 100%;
  height: 60px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  display: block;
  float: right;
  padding: 20px;
  display: none;
}
.Estimate_basket__L8u2X .Estimate_toggle__tc5K2 svg {
  width: 12px;
  height: auto;
  transform: rotate(180deg);
  float: right;
  margin-top: 10px;
}
.Estimate_basket__L8u2X li {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  list-style-type: none;
  gap: 10%;
}
.Estimate_basket__L8u2X li span:first-of-type {
  width: 70%;
  font-weight: 300;
  line-height: 28px;
}
.Estimate_basket__L8u2X li span:last-of-type {
  width: 20%;
  text-align: right;
}
.Estimate_basket__L8u2X .Estimate_total__y20q\\+ {
  font-size: 28px;
  font-weight: 600;
  text-align: right;
  display: block;
}
.Estimate_basket__L8u2X button {
  width: 100%;
  float: none;
  max-width: none;
}

.Estimate_bloc__ynJR8 {
  background-color: #FFFFFF;
  border: 1px solid #d8d8ff;
  border-radius: 12px;
  padding: 16px;
  margin-top: 12px;
  color: #00007a;
  font-weight: 300;
  line-height: 28px;
}
.Estimate_bloc__ynJR8 h2 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
}
.Estimate_bloc__ynJR8 li {
  list-style: none;
}

.Estimate_documents__hbAmV {
  margin: 0;
}
.Estimate_documents__hbAmV * {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Estimate_documents__hbAmV svg {
  margin-right: 4px;
}

.Estimate_response__56rLZ {
  max-width: none;
  margin: 20px 0 0 0;
}
.Estimate_response__56rLZ p {
  line-height: 24px;
  font-size: 14px;
  color: #7c1028;
}

@media screen and (max-width: 1064px) {
  .Estimate_estimate__6NItI {
    width: calc(100vw - 404px);
  }
}
@media screen and (max-width: 986px) {
  .Estimate_message__TWdH1 {
    width: calc(100vw - 40px);
    float: none;
  }
  .Estimate_estimate__6NItI {
    width: calc(100vw - 40px);
    padding-bottom: 90px;
  }
  .Estimate_basket__L8u2X {
    width: 100vw;
    float: none;
    position: fixed;
    bottom: 0;
    left: -20px;
    border-radius: 0;
  }
  .Estimate_basket__L8u2X .Estimate_toggle__tc5K2 {
    display: block;
  }
  .Estimate_basket__L8u2X .Estimate_quantity__4FbNK {
    display: inline;
  }
  .Estimate_basket__L8u2X .Estimate_inside__E8I65 {
    display: none;
  }
  .Estimate_basket__L8u2X.Estimate_open__C33t9 .Estimate_inside__E8I65 {
    display: block;
  }
}
@media screen and (max-width: 600px) {
  .Estimate_product__JgcDq li {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/pages/Estimate/Estimate.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACI,YAAA;EACA,cAAA;AAIJ;;AAAA;EACI,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,cCPO;EDQP,gBAAA;AAGJ;AADI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAGR;AAAI;EACI,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,sBAAA;AAER;AACI;EACI,WAAA;EACA,YAAA;EACA,sBAAA;AACR;AAEI;EACI,6BAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;AAAR;AAEQ;EACI,sBAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AAAZ;;AAKA;EACI,6BAAA;AAFJ;;AAKA;EACI,yBAAA;EACA,0BAAA;AAFJ;;AAKA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBC5EO;ED6EP,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cC3EO;ED4EP,wBAAA;EACA,YAAA;AAFJ;AAII;EACI,aCpFG;ADkFX;;AAMA;EACI,WAAA;EACA,YAAA;AAHJ;;AAMA;EACI,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,cC/FO;EDgGP,YAAA;EACA,cAAA;AAHJ;AAKI;EACI,eAAA;EACA,gBAAA;AAHR;AAMI;EACI,aAAA;AAJR;AAOI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;AALR;AAOQ;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;AALZ;AASI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,QAAA;AAPR;AASQ;EACI,UAAA;EACA,gBAAA;EACA,iBAAA;AAPZ;AASQ;EACI,UAAA;EACA,iBAAA;AAPZ;AAWI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AATR;AAYI;EACI,WAAA;EACA,WAAA;EACA,eAAA;AAVR;;AAcA;EACI,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,cCvKO;EDwKP,gBAAA;EACA,iBAAA;AAXJ;AAaI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAXR;AAcI;EACI,gBAAA;AAZR;;AAgBA;EACI,SAAA;AAbJ;AAeI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAbR;AAgBI;EACI,iBAAA;AAdR;;AAkBA;EACI,eAAA;EACA,kBAAA;AAfJ;AAiBI;EACI,iBAAA;EACA,eAAA;EACA,cClLE;ADmKV;;AAmBA;EACI;IACI,0BAAA;EAhBN;AACF;AAoBA;EACI;IACI,yBAAA;IACA,WAAA;EAlBN;EAoBE;IACI,yBAAA;IACA,oBAAA;EAlBN;EAoBE;IACI,YAAA;IACA,WAAA;IACA,eAAA;IACA,SAAA;IACA,WAAA;IACA,gBAAA;EAlBN;EAoBM;IACI,cAAA;EAlBV;EAqBM;IACI,eAAA;EAnBV;EAsBM;IACI,aAAA;EApBV;EAwBU;IACI,cAAA;EAtBd;AACF;AA2BA;EACI;IACI,sBAAA;EAzBN;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.estimate{\n    width: 660px;\n    margin: 0 20px;\n}\n\n\n.product{\n    border: 1px solid colors.$primary2;\n    background-color: #FFFFFF;\n    padding: 20px;\n    border-radius: 12px;\n    color: colors.$primary8;\n    margin-top: 28px;\n\n    h2{\n        font-size: 16px;\n        font-weight: 600;\n        margin-bottom: 15px;\n    }\n\n    h3{\n        font-size: 16px;\n        font-weight: 400;\n        width: calc(100% - 25px);\n        margin: 10px 0 5px 5px;\n    }\n\n    svg{\n        width: 20px;\n        height: auto;\n        vertical-align: middle;\n    }\n\n    ul{\n        border-top: 1px solid colors.$primary2;\n        margin-top: 20px;\n        margin-bottom: 0;\n        padding-top: 10px;\n        display: flex;\n        flex-wrap: wrap;\n        gap: 16px;\n\n        li{\n            width: calc(50% - 8px);\n            list-style-type: none;\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n        }\n    }\n}\n\n.title{\n    margin-bottom: 5px!important;\n}\n\n.link a{\n    color: colors.$primary6 !important;\n    text-decoration: underline;\n}\n\n.price{\n    display: block;\n    font-size: 20px;\n    font-weight: 500;\n    margin-top: 15px;\n    margin-bottom: 10px;\n}\n\n.message{\n    width: 348px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    background-color: colors.$primary2;\n    padding: 12px;\n    border-radius: 12px;\n    font-weight: 300;\n    font-size: 14px;\n    color: colors.$primary8;\n    margin: 0 20px 16px 20px;\n    float: right;\n\n    path{\n        fill: colors.$primary4;\n    }\n}\n\n.clear{\n    clear: both;\n    float: right;\n}\n\n.basket{\n    width: 348px;\n    border: 1px solid colors.$primary2;\n    background-color: #FFFFFF;\n    padding: 20px;\n    border-radius: 12px;\n    color: colors.$primary8;\n    float: right;\n    margin: 0 20px;\n\n    h2{\n        font-size: 20px;\n        font-weight: 500;\n    }\n\n    .quantity{\n        display: none;\n    }\n\n    .toggle{\n        width: 100%;\n        height: 60px;\n        position: absolute;\n        top: 0;\n        right: 0;\n        cursor: pointer;\n        display: block;\n        float: right;\n        padding: 20px;\n        display: none;\n\n        svg{\n            width: 12px;\n            height: auto;\n            transform: rotate(180deg);\n            float: right;\n            margin-top: 10px;\n        }\n    }\n\n    li{\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n        list-style-type: none;\n        gap: 10%;\n\n        span:first-of-type{\n            width: 70%;\n            font-weight: 300;\n            line-height: 28px;\n        }\n        span:last-of-type{\n            width: 20%;\n            text-align: right;\n        }\n    }\n\n    .total{\n        font-size: 28px;\n        font-weight: 600;\n        text-align: right;\n        display: block;\n    }\n\n    button{\n        width: 100%;\n        float: none;\n        max-width: none;\n    }\n}\n\n.bloc{\n    background-color: #FFFFFF;\n    border: 1px solid colors.$primary2;\n    border-radius: 12px;\n    padding: 16px;\n    margin-top: 12px;\n    color: colors.$primary8;\n    font-weight: 300;\n    line-height: 28px;\n\n    h2{\n        font-size: 16px;\n        font-weight: 600;\n        margin-bottom: 8px;\n    }\n\n    li{\n        list-style: none;\n    }\n}\n\n.documents{\n    margin: 0;\n\n    *{\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    svg{\n        margin-right: 4px;\n    }\n}\n\n.response{\n    max-width: none;\n    margin: 20px 0 0 0;\n\n    p{\n        line-height: 24px;\n        font-size: 14px;\n        color: colors.$danger7;\n    }\n}\n\n@media screen and (max-width: 1064px) {\n    .estimate{\n        width: calc(100vw - (348px + 40px + 16px));\n    }\n}\n\n\n@media screen and (max-width: 986px) {\n    .message{\n        width: calc(100vw - 40px);\n        float: none;\n    }\n    .estimate{\n        width: calc(100vw - 40px);\n        padding-bottom: 90px;\n    }\n    .basket{\n        width: 100vw;\n        float: none;\n        position: fixed;\n        bottom: 0;\n        left: -20px;\n        border-radius: 0;\n\n        .toggle{\n            display: block;\n        }\n\n        .quantity{\n            display: inline;\n        }\n\n        .inside{\n            display: none;\n        }\n\n        &.open{\n            .inside{\n                display: block;\n            }\n        }\n    }\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n    .product li{\n        width: 100%!important;\n    }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"estimate": `Estimate_estimate__6NItI`,
	"product": `Estimate_product__JgcDq`,
	"title": `Estimate_title__Zv8Gm`,
	"link": `Estimate_link__x50Jl`,
	"price": `Estimate_price__xjXW7`,
	"message": `Estimate_message__TWdH1`,
	"clear": `Estimate_clear__7zrRE`,
	"basket": `Estimate_basket__L8u2X`,
	"quantity": `Estimate_quantity__4FbNK`,
	"toggle": `Estimate_toggle__tc5K2`,
	"total": `Estimate_total__y20q+`,
	"bloc": `Estimate_bloc__ynJR8`,
	"documents": `Estimate_documents__hbAmV`,
	"response": `Estimate_response__56rLZ`,
	"inside": `Estimate_inside__E8I65`,
	"open": `Estimate_open__C33t9`
};
export default ___CSS_LOADER_EXPORT___;
